// Generated by purs version 0.13.8
"use strict";
var Control_Applicative = require("../Control.Applicative/index.js");
var Control_Bind = require("../Control.Bind/index.js");
var Control_MonadZero = require("../Control.MonadZero/index.js");
var Data_Array = require("../Data.Array/index.js");
var Data_EuclideanRing = require("../Data.EuclideanRing/index.js");
var Data_Foldable = require("../Data.Foldable/index.js");
var Data_FoldableWithIndex = require("../Data.FoldableWithIndex/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Data_Semigroup = require("../Data.Semigroup/index.js");
var Data_Show = require("../Data.Show/index.js");
var Effect = require("../Effect/index.js");
var Effect_Class = require("../Effect.Class/index.js");
var Effect_Class_Console = require("../Effect.Class.Console/index.js");
var LinearIndex = function (x) {
    return x;
};
var toPos = function (v) {
    return function (ix) {
        return {
            x: Data_EuclideanRing.mod(Data_EuclideanRing.euclideanRingInt)(ix)(v.width),
            y: Data_EuclideanRing.div(Data_EuclideanRing.euclideanRingInt)(ix)(v.width)
        };
    };
};
var insertAt = function (v) {
    return function (t) {
        return function (v1) {
            return Control_Bind.discard(Control_Bind.discardUnit)(Data_Maybe.bindMaybe)(Control_MonadZero.guard(Data_Maybe.monadZeroMaybe)(v.x < v1.width))(function () {
                return Control_Bind.discard(Control_Bind.discardUnit)(Data_Maybe.bindMaybe)(Control_MonadZero.guard(Data_Maybe.monadZeroMaybe)(v.x >= 0))(function () {
                    return Control_Bind.discard(Control_Bind.discardUnit)(Data_Maybe.bindMaybe)(Control_MonadZero.guard(Data_Maybe.monadZeroMaybe)(v.y < v1.height))(function () {
                        return Control_Bind.discard(Control_Bind.discardUnit)(Data_Maybe.bindMaybe)(Control_MonadZero.guard(Data_Maybe.monadZeroMaybe)(v.y >= 0))(function () {
                            return Control_Bind.bind(Data_Maybe.bindMaybe)(Data_Array.updateAt(v.x + (v.y * v1.width | 0) | 0)(t)(v1.values))(function (values$prime) {
                                return Control_Applicative.pure(Data_Maybe.applicativeMaybe)({
                                    width: v1.width,
                                    height: v1.height,
                                    values: values$prime
                                });
                            });
                        });
                    });
                });
            });
        };
    };
};
var indices = function (v) {
    return Control_Bind.bind(Control_Bind.bindArray)(Data_Array.range(0)(v.width - 1 | 0))(function (x) {
        return Control_Bind.bind(Control_Bind.bindArray)(Data_Array.range(0)(v.height - 1 | 0))(function (y) {
            return Control_Applicative.pure(Control_Applicative.applicativeArray)({
                x: x,
                y: y
            });
        });
    });
};
var index = function (v) {
    return function (v1) {
        return Control_Bind.discard(Control_Bind.discardUnit)(Data_Maybe.bindMaybe)(Control_MonadZero.guard(Data_Maybe.monadZeroMaybe)(v1.x < v.width))(function () {
            return Control_Bind.discard(Control_Bind.discardUnit)(Data_Maybe.bindMaybe)(Control_MonadZero.guard(Data_Maybe.monadZeroMaybe)(v1.x >= 0))(function () {
                return Control_Bind.discard(Control_Bind.discardUnit)(Data_Maybe.bindMaybe)(Control_MonadZero.guard(Data_Maybe.monadZeroMaybe)(v1.y < v.height))(function () {
                    return Control_Bind.discard(Control_Bind.discardUnit)(Data_Maybe.bindMaybe)(Control_MonadZero.guard(Data_Maybe.monadZeroMaybe)(v1.y >= 0))(function () {
                        return Data_Array.index(v.values)(v1.x + (v1.y * v.width | 0) | 0);
                    });
                });
            });
        });
    };
};
var foldLI = new Data_Foldable.Foldable(function (dictMonoid) {
    return function (f) {
        return function (v) {
            return Data_Foldable.foldMap(Data_Foldable.foldableArray)(dictMonoid)(f)(v.values);
        };
    };
}, function (f) {
    return function (z) {
        return function (v) {
            return Data_Foldable.foldl(Data_Foldable.foldableArray)(f)(z)(v.values);
        };
    };
}, function (f) {
    return function (z) {
        return function (v) {
            return Data_Foldable.foldr(Data_Foldable.foldableArray)(f)(z)(v.values);
        };
    };
});
var foldWithPosition = new Data_FoldableWithIndex.FoldableWithIndex(function () {
    return foldLI;
}, function (dictMonoid) {
    return function (f) {
        return function (v) {
            return Data_FoldableWithIndex.foldMapWithIndex(Data_FoldableWithIndex.foldableWithIndexArray)(dictMonoid)(function (i) {
                return function (m) {
                    return f(toPos(v)(i))(m);
                };
            })(v.values);
        };
    };
}, function (f) {
    return function (z) {
        return function (v) {
            return Data_FoldableWithIndex.foldlWithIndex(Data_FoldableWithIndex.foldableWithIndexArray)(function (i) {
                return function (b) {
                    return function (a) {
                        return f(toPos(v)(i))(b)(a);
                    };
                };
            })(z)(v.values);
        };
    };
}, function (f) {
    return function (z) {
        return function (v) {
            return Data_FoldableWithIndex.foldrWithIndex(Data_FoldableWithIndex.foldableWithIndexArray)(function (i) {
                return function (a) {
                    return function (b) {
                        return f(toPos(v)(i))(a)(b);
                    };
                };
            })(z)(v.values);
        };
    };
});
var fill = function (width) {
    return function (height) {
        return function (x) {
            return {
                width: width,
                height: height,
                values: Data_Array.replicate(width * height | 0)(x)
            };
        };
    };
};
var chunks = function (v) {
    return function (v1) {
        if (v1.length === 0) {
            return [  ];
        };
        return Data_Semigroup.append(Data_Semigroup.semigroupArray)(Control_Applicative.pure(Control_Applicative.applicativeArray)(Data_Array.take(v)(v1)))(chunks(v)(Data_Array.drop(v)(v1)));
    };
};
var printLinearIndex = function (dictShow) {
    return function (v) {
        return Data_Foldable.traverse_(Effect.applicativeEffect)(Data_Foldable.foldableArray)((function () {
            var $66 = Effect_Class_Console.log(Effect_Class.monadEffectEffect);
            var $67 = Data_Show.show(Data_Show.showArray(dictShow));
            return function ($68) {
                return $66($67($68));
            };
        })())(chunks(v.width)(v.values));
    };
};
module.exports = {
    LinearIndex: LinearIndex,
    printLinearIndex: printLinearIndex,
    chunks: chunks,
    fill: fill,
    indices: indices,
    index: index,
    insertAt: insertAt,
    toPos: toPos,
    foldLI: foldLI,
    foldWithPosition: foldWithPosition
};
